import PropTypes from 'prop-types';
import React from 'react';
import {
 ButtonToolbar,
 Button,
} from 'react-bootstrap';

import { tourType } from './CatchPropTypes';
import TourBadge from './TourBadge';
import TourListToolbar from './TourListToolbar';
import TourEditModal from './TourEditModal';
import TourTableView from './TourTableView';

class TourList extends React.Component {
  constructor() {
    super();
    const savedView = localStorage.getItem('showView');
    this.state = {
      show: false,
      //showView:false,
      showView: savedView ? JSON.parse(savedView) : true,
    };

    this.handleAddTour = this.handleAddTour.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.changeShowView = this.changeShowView.bind(this);
    this.changePinStatus = this.changePinStatus.bind(this);
  }
  handleAddTour() {
    this.setState({ show: true });
  }

  handleClose() {
    this.setState({ show: false });
  }

  changeShowView(){
    // if(this.state.showView==false){
    //   this.setState({ showView: true });
    // } else{
    //   this.setState({ showView: false });
    // }

    this.setState(
      (prevState) => ({ showView: !prevState.showView }),
      () => {
        // Save the current view preference to localStorage
        localStorage.setItem('showView', JSON.stringify(this.state.showView));
      }
    );
  }
  changePinStatus(tour){
    const id = tour.id;
    const payload ={'tour':tour.id,'pin':tour.pin_tour};
    this.props.changeTourPin(id,payload,(response)=>{
      console.log("response")
    });
  }

  render() {
    
    const auth = JSON.parse(sessionStorage.getItem('auth'));
    const newTour = {
      manager : auth.profile.user.id.toString()
    };
    const tours = [];
    this.props.tours.forEach((tour) => {
      if (!this.props.filter[tour.state]) {
        tours.push(<TourBadge tour={tour} key={tour.id} changePinStatus={this.changePinStatus} />);
      }
    });
    const tourTable = <TourTableView filter={this.props.filter} tours={this.props.tours} changePinStatus={this.changePinStatus}/>;
    return (
      <div className="container-fluid">
        <div className="row tour-head">
          <div className="col-xs-6 col-sm-6 col-md-6 tour-headText">
            <h2>Travel Projects</h2>
          </div>
          <div className="col-xs-6 col-sm-6 col-md-6 tour-headBar">
            <ButtonToolbar className="tour-headBtn">
              <TourListToolbar
                filter={this.props.filter}
                tourFilterSet={this.props.tourFilterSet}
                isTourManager={this.props.isTourManager}
                handleAddTour={this.handleAddTour}
              />
            </ButtonToolbar>
          </div>
        </div>
        <Button style={{ float: 'right' }} title={this.state.showView?("List View"):("Card View")} onClick={this.changeShowView}>{this.state.showView?(<i className="fa fa-bars"></i>):(<i className="fa fa-th-large"></i>)}</Button><br/>
        <hr />
        <div className="row">
          {this.state.showView?(tourTable):(tours)}
          { !this.props.isTourManager &&
          (
          <div className="col-sm-6 tour-container">
            <div className="add-tour">
              <Button onClick={this.handleAddTour} bsStyle="success">
                + Add Travel Project
              </Button>
              <TourEditModal
                tour={newTour}
                show={this.state.show}
                onClose={this.handleClose}
                addTour={this.props.addTour}
                editTour={this.props.editTour}
                requestTourManagers={this.props.requestTourManagers}
                tourManagers = {this.props.tourManagers}
              />
            </div>
          </div>
        )}
        </div>
      </div>
    );
  }
}
TourList.propTypes = {
  tours: PropTypes.arrayOf(PropTypes.shape(tourType)).isRequired,
  filter: PropTypes.object.isRequired,
  addTour: PropTypes.func.isRequired,
  editTour: PropTypes.func.isRequired,
  isTourManager: PropTypes.bool.isRequired,
  tourFilterSet: PropTypes.func.isRequired,
};
export default TourList;



// WEBPACK FOOTER //
// src/routes/tours/components/TourList.js